import { ParishRepository, Parish, ParishCode, ParishName } from '@/Domain/Localization/Parish'
import { CountyCode } from '@/Domain/Localization/County'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
interface StoredParishes {
  [key: number]: Parish[];
}
const parishes: StoredParishes = {
  150001: [
    new Parish(new ParishCode(1), new ParishName('Abegondo (Santa Eulalia)')),
    new Parish(new ParishCode(2), new ParishName('Cabanas (San Xulián)')),
    new Parish(new ParishCode(3), new ParishName('Cerneda (San Salvador)'))
  ],
  150002: [
    new Parish(new ParishCode(4), new ParishName('Cos (Santo Estevo)')),
    new Parish(new ParishCode(5), new ParishName('Crendes (San Pedro)')),
    new Parish(new ParishCode(6), new ParishName('Cullergondo (Santa Mar\u00eda)')),
    new Parish(new ParishCode(7), new ParishName('Figueroa (San Miguel)'))
  ],
  150003: [
    new Parish(new ParishCode(8), new ParishName('Folgoso (Santa Dorotea)')),
    new Parish(new ParishCode(9), new ParishName('Leiro (Santa Eulalia)')),
    new Parish(new ParishCode(10), new ParishName('Mabegondo (Santiso)'))
  ]
}

export class InMemoryParishRepository implements ParishRepository {
  async byCountyId (countyCode: CountyCode): Promise<Parish[]> {
    await wait(400)
    const code = countyCode.value()
    let foundParishes: Parish[] = []
    for (const key in parishes) {
      if (key === code.toString()) {
        foundParishes = parishes[code]
      }
    }
    return foundParishes
  }
}
